import { Transform } from 'class-transformer';
import { PageCriteria } from '../../../shared/model/local/pagination/page-criteria';
import {
  ArrayConversion,
  BooleanConversion,
} from '../../../shared/helper/transform.helper';
import { UserType } from '../../../domain/user/model/user-type';

export class UserPageCriteriaDto extends PageCriteria {
  @Transform(BooleanConversion)
  enabled?: boolean;

  @Transform(ArrayConversion)
  userTypes?: UserType[];

  constructor() {
    super();
  }
}
